import { TEXT_SCALE_PROPS } from "@lhd/constants";
import styled from "styled-components";

type Props = TEXT_SCALE_PROPS & {
  isCustomHeaderScroll?: boolean;
};

export const Styled = styled.div<Props>`
  overflow: auto;
  overflow-y: hidden;
  scrollbar-width: auto;

  height: ${({ isCustomHeaderScroll }) =>
    isCustomHeaderScroll ? "15px" : "14px"};

  //scrollbar-color: var(--color-thumb-scroll) var(--color-track-scroll);

  .horizontal-scroll-bar-inside {
    height: 1px;
  }
`;
